<template>
  <v-container fluid class="vp-page">
    <header class="vp-hero">
      <div class="vp-hero-left">
        <span class="vp-mark">
          <v-icon color="white">mdi-school</v-icon>
        </span>
        <div>
          <h1>Validación pagos curso</h1>
          <p>Consulta y gestiona los pagos de los cursos registrados</p>
        </div>
      </div>
      <div class="vp-hero-actions">
        <button type="button" class="vp-btn vp-btn-green" @click="dialogResumen = true">
          <v-icon small color="white">mdi-file-excel-outline</v-icon>
          Resumen / Excel
        </button>
        <button type="button" class="vp-btn vp-btn-blue" :disabled="cargando" @click="consultar">
          <v-icon small color="white">mdi-refresh</v-icon>
          Actualizar
        </button>
      </div>
    </header>

    <section class="vp-panel">
      <div class="vp-filters">
        <div class="vp-filter">
          <v-icon small class="vp-filter-ico ico-ok">mdi-check-circle-outline</v-icon>
          <div class="vp-filter-copy">
            <span class="vp-filter-label">Estado</span>
            <v-select
              v-model="filtros.estado"
              :items="opcionesEstado"
              dense
              solo
              flat
              hide-details
              @change="consultar"
            ></v-select>
          </div>
        </div>
        <div class="vp-filter">
          <v-icon small class="vp-filter-ico ico-curso">mdi-cube-outline</v-icon>
          <div class="vp-filter-copy">
            <span class="vp-filter-label">Curso</span>
            <v-select
              v-model="filtros.curso_id"
              :items="cursosFiltro"
              item-text="curso_nombre"
              item-value="curso_id"
              dense
              solo
              flat
              hide-details
              @change="cambiarCurso"
            ></v-select>
          </div>
        </div>
        <div class="vp-filter">
          <v-icon small class="vp-filter-ico ico-nivel">mdi-layers-outline</v-icon>
          <div class="vp-filter-copy">
            <span class="vp-filter-label">Nivel</span>
            <v-select
              v-model="filtros.nivel_id"
              :items="nivelesFiltro"
              item-text="nivel_nombre"
              item-value="nivel_id"
              dense
              solo
              flat
              hide-details
              @change="consultar"
            ></v-select>
          </div>
        </div>
        <div class="vp-filter">
          <v-icon small class="vp-filter-ico ico-fecha">mdi-calendar-blank-outline</v-icon>
          <div class="vp-filter-copy">
            <span class="vp-filter-label">Desde</span>
            <v-text-field
              v-model="filtros.fecha_desde"
              type="date"
              dense
              solo
              flat
              hide-details
              @change="consultar"
            ></v-text-field>
          </div>
        </div>
        <div class="vp-filter">
          <v-icon small class="vp-filter-ico ico-fecha">mdi-calendar-blank-outline</v-icon>
          <div class="vp-filter-copy">
            <span class="vp-filter-label">Hasta</span>
            <v-text-field
              v-model="filtros.fecha_hasta"
              type="date"
              dense
              solo
              flat
              hide-details
              @change="consultar"
            ></v-text-field>
          </div>
        </div>
        <div class="vp-filter vp-filter-search">
          <v-icon small class="vp-filter-ico ico-fecha">mdi-magnify</v-icon>
          <v-text-field
            v-model="filtros.busqueda"
            placeholder="Matrícula / alumno..."
            dense
            solo
            flat
            hide-details
            clearable
            @keyup.enter="consultar"
            @click:clear="consultarLuego"
          ></v-text-field>
        </div>
      </div>

      <v-data-table
        class="vp-table"
        :headers="headers"
        :items="pagosVista"
        :loading="cargando"
        item-key="_row"
        :items-per-page="10"
        :footer-props="footerProps"
      >
        <template v-slot:header.matricula="{ header }">
          <span class="vp-th"><v-icon x-small>mdi-account-outline</v-icon>{{ header.text }}</span>
        </template>
        <template v-slot:header.nombre_alumno="{ header }">
          <span class="vp-th"><v-icon x-small>mdi-account-outline</v-icon>{{ header.text }}</span>
        </template>
        <template v-slot:header.curso_nombre="{ header }">
          <span class="vp-th"><v-icon x-small>mdi-book-open-variant</v-icon>{{ header.text }}</span>
        </template>
        <template v-slot:header.nivel_nombre="{ header }">
          <span class="vp-th"><v-icon x-small>mdi-layers-outline</v-icon>{{ header.text }}</span>
        </template>
        <template v-slot:header.monto="{ header }">
          <span class="vp-th"><v-icon x-small>mdi-currency-usd</v-icon>{{ header.text }}</span>
        </template>
        <template v-slot:header.fecha_pago="{ header }">
          <span class="vp-th"><v-icon x-small>mdi-calendar-blank-outline</v-icon>{{ header.text }}</span>
        </template>
        <template v-slot:header.estado="{ header }">
          <span class="vp-th"><v-icon x-small>mdi-check-circle-outline</v-icon>{{ header.text }}</span>
        </template>
        <template v-slot:header.antiguedad="{ header }">
          <span class="vp-th"><v-icon x-small>mdi-clock-outline</v-icon>{{ header.text }}</span>
        </template>
        <template v-slot:item.monto="{ item }">
          <span class="vp-money">${{ formatMonto(item.monto) }} {{ item.moneda }}</span>
        </template>
        <template v-slot:item.fecha_pago="{ item }">
          <span class="vp-fecha">
            <v-icon x-small class="mr-1">mdi-calendar-blank-outline</v-icon>
            {{ formatFecha(item.fecha_pago) }}
          </span>
        </template>
        <template v-slot:item.estado="{ item }">
          <span class="vp-badge" :class="'is-' + item.estado">
            <v-icon x-small color="white">{{ iconoEstado(item.estado) }}</v-icon>
            {{ etiquetaEstado(item.estado) }}
          </span>
          <span v-if="item.es_vigente" class="vp-vigente">vigente</span>
        </template>
        <template v-slot:item.antiguedad="{ item }">
          <span class="vp-age" :class="{ 'is-late': esViejoPendiente(item) }">
            <v-icon x-small>mdi-clock-outline</v-icon>
            {{ textoAntiguedad(item) }}
          </span>
          <span v-if="esViejoPendiente(item)" class="vp-late">+24h</span>
        </template>
        <template v-slot:item.acciones="{ item }">
          <button type="button" class="vp-eye" @click="abrirDetalle(item)">
            <v-icon small>mdi-eye-outline</v-icon>
          </button>
        </template>
        <template v-slot:footer.page-text="{ pageStart, pageStop, itemsLength }">
          <span class="vp-foot-count">
            <v-icon x-small class="mr-1">mdi-table</v-icon>
            Mostrando {{ pageStart }} - {{ pageStop }} de {{ itemsLength }} registros
          </span>
        </template>
      </v-data-table>
    </section>

    <!-- Detalle -->
    <v-dialog v-model="dialogDetalle" max-width="900" scrollable>
      <v-card v-if="pagoActivo">
        <v-card-title class="text-subtitle-1">
          {{ pagoActivo.matricula }} · {{ pagoActivo.nombre_alumno }}
          <v-spacer></v-spacer>
          <v-btn icon @click="dialogDetalle = false"><v-icon>mdi-close</v-icon></v-btn>
        </v-card-title>
        <v-card-text>
          <v-row>
            <v-col cols="12" md="5">
              <div class="mb-2"><b>Curso:</b> {{ pagoActivo.curso_nombre }}</div>
              <div class="mb-2"><b>Nivel:</b> {{ pagoActivo.nivel_nombre }}</div>
              <div class="mb-2"><b>Monto:</b> {{ formatMonto(pagoActivo.monto) }} {{ pagoActivo.moneda }}</div>
              <div class="mb-2"><b>Fecha pago:</b> {{ formatFecha(pagoActivo.fecha_pago) }}</div>
              <div class="mb-2"><b>Estado:</b> {{ pagoActivo.estado }}</div>
              <div v-if="pagoActivo.motivo" class="mb-2"><b>Motivo:</b> {{ pagoActivo.motivo }}</div>

              <v-textarea
                v-if="puedeDecidir"
                v-model="motivoRechazo"
                label="Motivo de rechazo"
                filled
                dense
                rows="2"
                hide-details
                class="mt-3"
              ></v-textarea>

              <div v-if="puedeDecidir" class="mt-3 d-flex">
                <v-btn color="success" small tile class="mr-2" :loading="guardando" @click="aprobar">
                  Aprobar
                </v-btn>
                <v-btn color="error" small tile outlined :loading="guardando" @click="rechazar">
                  Rechazar
                </v-btn>
              </div>
            </v-col>
            <v-col cols="12" md="7">
              <div v-if="esImagen(pagoActivo.comprobante_url)" class="comprobante-box">
                <img :src="pagoActivo.comprobante_url" alt="Comprobante" class="comprobante-img" />
              </div>
              <iframe
                v-else
                :src="pagoActivo.comprobante_url"
                class="comprobante-frame"
                title="Comprobante"
              ></iframe>
              <div class="mt-2">
                <a :href="pagoActivo.comprobante_url" target="_blank" rel="noopener">Abrir en pestaña</a>
              </div>
            </v-col>
          </v-row>
        </v-card-text>
      </v-card>
    </v-dialog>

    <!-- Resumen / export -->
    <v-dialog v-model="dialogResumen" max-width="760">
      <v-card class="rs-card">
        <header class="rs-head">
          <div>
            <p class="rs-kicker">Pagos del curso</p>
            <h2>Resumen por rango</h2>
            <p>El total solo cuenta el dinero que sí ingresó. Los rechazados quedan fuera.</p>
          </div>
          <button type="button" class="rs-close" @click="dialogResumen = false">
            <v-icon>mdi-close</v-icon>
          </button>
        </header>
        <div class="rs-body">
          <div class="rs-rango">
            <label class="rs-field">
              <span>Desde</span>
              <input v-model="resumen.fecha_desde" type="date" />
            </label>
            <label class="rs-field">
              <span>Hasta</span>
              <input v-model="resumen.fecha_hasta" type="date" />
            </label>
            <button type="button" class="vp-btn vp-btn-blue rs-calc" :disabled="cargandoResumen" @click="cargarResumen">
              {{ cargandoResumen ? 'Calculando…' : 'Calcular' }}
            </button>
          </div>

          <div v-if="resumenVista" class="rs-result">
            <div class="rs-stats">
              <article class="rs-stat is-money">
                <span>Dinero ingresado</span>
                <strong>${{ formatMonto(resumenVista.suma) }}</strong>
                <small>{{ resumenVista.cantidadIngreso }} {{ resumenVista.cantidadIngreso === 1 ? 'pago' : 'pagos' }}</small>
              </article>
              <article class="rs-stat is-out">
                <span>Rechazados</span>
                <strong>{{ resumenVista.rechazados }}</strong>
                <small>No entran al total</small>
              </article>
            </div>

            <h3>Por estado</h3>
            <div class="rs-estados">
              <span v-for="e in resumenVista.estados" :key="e.estado" class="vp-badge" :class="'is-' + e.estado">
                {{ etiquetaEstado(e.estado) }} · {{ e.cantidad }}
              </span>
            </div>

            <h3>Por curso / nivel</h3>
            <p v-if="!resumenVista.cursos.length" class="rs-empty">En este rango no hay pagos que hayan ingresado.</p>
            <div v-else class="rs-cursos">
              <article v-for="(r, i) in resumenVista.cursos" :key="'c-' + i" class="rs-curso">
                <div>
                  <strong>{{ r.curso_nombre }}</strong>
                  <span>{{ r.nivel_nombre }}</span>
                </div>
                <div class="rs-curso-nums">
                  <em>{{ r.cantidad }} {{ r.cantidad === 1 ? 'pago' : 'pagos' }}</em>
                  <b>${{ formatMonto(r.monto) }}</b>
                </div>
              </article>
            </div>

            <button type="button" class="vp-btn vp-btn-green rs-excel" @click="exportarExcelResumen">
              <v-icon small color="white">mdi-file-excel-outline</v-icon>
              Exportar a Excel
            </button>
          </div>
        </div>
      </v-card>
    </v-dialog>

    <Alerta v-if="respuestaAlerta" :parametros="parametros" />
  </v-container>
</template>

<script>
import Alerta from '@/components/alertas/Alerta.vue'
import validarErrores from '@/mixins/validarErrores'
import funcionesExcel from '@/mixins/funcionesExcel'

export default {
  name: 'ValidacionPagosCurso',
  components: { Alerta },
  mixins: [validarErrores, funcionesExcel],
  data: function () {
    return {
      cargando: false,
      guardando: false,
      cargandoResumen: false,
      pagos: [],
      cursos: [],
      niveles: [],
      filtros: {
        estado: 'todos',
        curso_id: 'todos',
        nivel_id: 'todos',
        fecha_desde: '',
        fecha_hasta: '',
        busqueda: '',
      },
      opcionesEstado: [
        { text: 'Todos', value: 'todos' },
        { text: 'Pendiente', value: 'pendiente' },
        { text: 'En revisión', value: 'en_revision' },
        { text: 'Aprobado', value: 'aprobado' },
        { text: 'Rechazado', value: 'rechazado' },
      ],
      footerProps: {
        'items-per-page-options': [5, 10, 25, 50],
        'items-per-page-text': 'Filas por página:',
      },
      headers: [
        { text: 'Matrícula', value: 'matricula' },
        { text: 'Alumno', value: 'nombre_alumno' },
        { text: 'Curso', value: 'curso_nombre' },
        { text: 'Nivel', value: 'nivel_nombre' },
        { text: 'Monto', value: 'monto' },
        { text: 'Fecha pago', value: 'fecha_pago' },
        { text: 'Estado', value: 'estado' },
        { text: 'Antigüedad', value: 'antiguedad', sortable: false },
        { text: 'Acciones', value: 'acciones', sortable: false, align: 'center', width: '90px' },
      ],
      dialogDetalle: false,
      pagoActivo: null,
      motivoRechazo: '',
      dialogResumen: false,
      resumen: { fecha_desde: '', fecha_hasta: '' },
      resumenData: null,
      parametros: { dialogError: false, mensaje: '', color: '' },
      respuestaAlerta: false,
    }
  },
  computed: {
    nivelesFiltrados: function () {
      var curso = this.filtros.curso_id
      if (!curso || curso === 'todos') return this.niveles
      return this.niveles.filter(function (n) { return n.curso_id === curso })
    },
    cursosFiltro: function () {
      return [{ curso_id: 'todos', curso_nombre: 'Todos' }].concat(this.unicosPor(this.cursos, 'curso_id'))
    },
    nivelesFiltro: function () {
      return [{ nivel_id: 'todos', nivel_nombre: 'Todos' }].concat(this.unicosPor(this.nivelesFiltrados, 'nivel_id'))
    },
    pagosVista: function () {
      return (this.pagos || []).map(function (p, i) {
        var id = p.pago_id || p.id || 'row'
        return Object.assign({}, p, { _row: String(id) + '-' + i })
      })
    },
    puedeDecidir: function () {
      if (!this.pagoActivo) return false
      return ['pendiente', 'en_revision'].indexOf(this.pagoActivo.estado) !== -1
    },
    resumenVista: function () {
      if (!this.resumenData) return null
      var pagos = this.resumenData.pagos || []
      var entran = pagos.filter(function (p) { return p.estado !== 'rechazado' })
      var porEstado = {}
      var cursos = {}
      var suma = 0
      pagos.forEach(function (p) {
        porEstado[p.estado] = (porEstado[p.estado] || 0) + 1
      })
      entran.forEach(function (p) {
        var monto = Number(p.monto) || 0
        suma += monto
        var clave = String(p.curso_nombre || '') + '|' + String(p.nivel_nombre || '')
        if (!cursos[clave]) {
          cursos[clave] = {
            curso_nombre: p.curso_nombre,
            nivel_nombre: p.nivel_nombre,
            cantidad: 0,
            monto: 0,
          }
        }
        cursos[clave].cantidad += 1
        cursos[clave].monto += monto
      })
      return {
        suma: Math.round(suma * 100) / 100,
        cantidadIngreso: entran.length,
        rechazados: pagos.length - entran.length,
        estados: Object.keys(porEstado).map(function (estado) {
          return { estado: estado, cantidad: porEstado[estado] }
        }),
        cursos: Object.keys(cursos).map(function (clave) { return cursos[clave] }),
      }
    },
  },
  created: function () {
    this.cargarCatalogos()
    this.consultar()
  },
  methods: {
    formatMonto: function (v) {
      var n = Number(v)
      if (!Number.isFinite(n)) return v
      var parts = n.toFixed(2).split('.')
      parts[0] = parts[0].replace(/\B(?=(\d{3})+(?!\d))/g, ',')
      return parts.join('.')
    },
    consultarLuego: function () {
      var self = this
      this.$nextTick(function () { self.consultar() })
    },
    formatFecha: function (v) {
      if (!v) return ''
      var d = new Date(v)
      if (Number.isNaN(d.getTime())) return String(v)
      return d.toLocaleString('es-MX')
    },
    etiquetaEstado: function (estado) {
      if (estado === 'aprobado') return 'Aprobado'
      if (estado === 'rechazado') return 'Rechazado'
      if (estado === 'en_revision') return 'En revisión'
      if (estado === 'pendiente') return 'Pendiente'
      return estado || ''
    },
    iconoEstado: function (estado) {
      if (estado === 'aprobado') return 'mdi-check'
      if (estado === 'rechazado') return 'mdi-close'
      if (estado === 'en_revision') return 'mdi-clock-outline'
      return 'mdi-timer-sand'
    },
    unicosPor: function (lista, campo) {
      var vistos = {}
      var salida = []
      ;(lista || []).forEach(function (item) {
        if (!item) return
        var id = item[campo]
        if (id === undefined || id === null || id === '' || vistos[id]) return
        vistos[id] = true
        salida.push(item)
      })
      return salida
    },
    cambiarCurso: function () {
      this.filtros.nivel_id = 'todos'
      this.consultar()
    },
    horasDesde: function (item) {
      var t = new Date(item.created_at || item.fecha_pago).getTime()
      if (!Number.isFinite(t)) return 0
      return (Date.now() - t) / 3600000
    },
    esViejoPendiente: function (item) {
      return item.estado === 'pendiente' && this.horasDesde(item) > 24
    },
    textoAntiguedad: function (item) {
      var h = this.horasDesde(item)
      if (h < 1) return Math.round(h * 60) + ' min'
      if (h < 48) return Math.round(h) + ' h'
      return Math.round(h / 24) + ' d'
    },
    esImagen: function (url) {
      return /\.(png|jpe?g|gif|webp|bmp)(\?|$)/i.test(String(url || ''))
    },
    cargarCatalogos: function () {
      var self = this
      this.$http.post('pagos.curso.catalogos', {}).then(function (r) {
        self.cursos = (r.data && r.data.cursos) || []
        self.niveles = (r.data && r.data.niveles) || []
      }).catch(function () {})
    },
    consultar: function () {
      var self = this
      this.cargando = true
      var f = this.filtros
      function limpio(v) {
        if (!v || v === 'todos') return null
        return v
      }
      this.$http
        .post('pagos.curso.list', {
          estado: limpio(f.estado),
          curso_id: limpio(f.curso_id),
          nivel_id: limpio(f.nivel_id),
          fecha_desde: f.fecha_desde || null,
          fecha_hasta: f.fecha_hasta || null,
          busqueda: f.busqueda || null,
        })
        .then(function (r) {
          var body = r.data || {}
          self.pagos = body.pagos || []
        })
        .catch(function (e) {
          var data = e.response && e.response.data
          var msg = (data && data.message) || e.message || 'Error al listar'
          self.validarError(msg)
        })
        .finally(function () {
          self.cargando = false
        })
    },
    abrirDetalle: function (item) {
      var self = this
      this.motivoRechazo = ''
      this.pagoActivo = item
      this.dialogDetalle = true
      if (item.estado === 'pendiente') {
        this.$http
          .post('pagos.curso.marcar-revision', { pago_id: item.pago_id })
          .then(function (r) {
            if (r.data && r.data.pago) {
              self.pagoActivo = r.data.pago
              self.consultar()
            }
          })
          .catch(function () {})
      }
    },
    aprobar: function () {
      var self = this
      this.guardando = true
      this.$http
        .post('pagos.curso.aprobar', { pago_id: this.pagoActivo.pago_id })
        .then(function (r) {
          self.pagoActivo = r.data.pago
          self.parametros = { dialogError: true, mensaje: 'Pago aprobado', color: 'success' }
          self.respuestaAlerta = true
          self.consultar()
        })
        .catch(function (e) {
          self.validarError((e.response && e.response.data && e.response.data.message) || 'No se pudo aprobar')
        })
        .finally(function () {
          self.guardando = false
        })
    },
    rechazar: function () {
      var self = this
      if (!String(this.motivoRechazo || '').trim()) {
        return this.validarErrorDirecto('El motivo es obligatorio para rechazar')
      }
      this.guardando = true
      this.$http
        .post('pagos.curso.rechazar', {
          pago_id: this.pagoActivo.pago_id,
          motivo: this.motivoRechazo,
        })
        .then(function (r) {
          self.pagoActivo = r.data.pago
          self.parametros = { dialogError: true, mensaje: 'Pago rechazado', color: 'success' }
          self.respuestaAlerta = true
          self.consultar()
        })
        .catch(function (e) {
          self.validarError((e.response && e.response.data && e.response.data.message) || 'No se pudo rechazar')
        })
        .finally(function () {
          self.guardando = false
        })
    },
    cargarResumen: function () {
      var self = this
      if (!this.resumen.fecha_desde || !this.resumen.fecha_hasta) {
        return this.validarErrorDirecto('Indica el rango de fechas')
      }
      this.cargandoResumen = true
      this.$http
        .post('pagos.curso.resumen', {
          fecha_desde: this.resumen.fecha_desde + ' 00:00:00',
          fecha_hasta: this.resumen.fecha_hasta + ' 23:59:59',
        })
        .then(function (r) {
          self.resumenData = r.data
        })
        .catch(function (e) {
          self.validarError((e.response && e.response.data && e.response.data.message) || 'Error resumen')
        })
        .finally(function () {
          self.cargandoResumen = false
        })
    },
    exportarExcelResumen: function () {
      if (!this.resumenData || !(this.resumenData.pagos || []).length) {
        return this.validarErrorDirecto('No hay pagos en el rango')
      }
      var filas = (this.resumenData.pagos || []).map(function (p) {
        return {
          Matrícula: p.matricula,
          Alumno: p.nombre_alumno,
          'Curso ID': p.curso_id,
          Curso: p.curso_nombre,
          'Nivel ID': p.nivel_id,
          Nivel: p.nivel_nombre,
          Monto: Number(p.monto),
          Moneda: p.moneda,
          'Fecha pago': p.fecha_pago,
          Estado: p.estado,
          Motivo: p.motivo || '',
          'Pago ID': p.pago_id,
          'Creado en': p.created_at,
          'Actualizado en': p.updated_at,
          'Validado en': p.validado_en || '',
          Vigente: p.es_vigente ? 'Sí' : 'No',
        }
      })
      var contados = filas.filter(function (f) { return f.Estado !== 'rechazado' })
      var suma = contados.reduce(function (acc, f) {
        return acc + (Number(f.Monto) || 0)
      }, 0)
      filas.push({
        Matrícula: 'TOTALES',
        Alumno: '',
        'Curso ID': '',
        Curso: '',
        'Nivel ID': '',
        Nivel: '',
        Monto: Math.round(suma * 100) / 100,
        Moneda: 'MXN',
        'Fecha pago': '',
        Estado: 'N=' + contados.length,
        Motivo: 'Sin rechazados',
        'Pago ID': '',
        'Creado en': '',
        'Actualizado en': '',
        'Validado en': '',
        Vigente: '',
      })
      this.exportarExcelDirecto(filas, 'pagos_curso_' + this.resumen.fecha_desde + '_' + this.resumen.fecha_hasta)
    },
  },
}
</script>

<style scoped>
.vp-page {
  background: #e8eef6;
  min-height: calc(100vh - 64px);
  padding: 18px 18px 28px;
}
.vp-hero {
  position: relative;
  overflow: hidden;
  display: flex;
  align-items: center;
  justify-content: space-between;
  gap: 16px;
  flex-wrap: wrap;
  background: linear-gradient(115deg, #0c1b40 0%, #122a5c 55%, #1a3d86 100%);
  border-radius: 22px;
  padding: 22px 26px;
  color: #fff;
}
.vp-hero::after {
  content: '';
  position: absolute;
  right: -40px;
  top: -80px;
  width: 280px;
  height: 220px;
  background: radial-gradient(circle, rgba(255,255,255,.16), transparent 70%);
  pointer-events: none;
}
.vp-hero-left { display: flex; align-items: center; gap: 14px; position: relative; z-index: 1; }
.vp-mark {
  width: 46px;
  height: 46px;
  border-radius: 14px;
  background: #2f6bff;
  display: inline-flex;
  align-items: center;
  justify-content: center;
  flex: none;
  box-shadow: 0 8px 18px rgba(47, 107, 255, .35);
}
.vp-hero h1 { margin: 0; font-size: 26px; font-weight: 800; letter-spacing: -0.02em; line-height: 1.1; }
.vp-hero p { margin: 4px 0 0; font-size: 13.5px; color: rgba(255,255,255,.72); }
.vp-hero-actions { display: flex; gap: 10px; position: relative; z-index: 1; flex-wrap: wrap; }
.vp-btn {
  display: inline-flex;
  align-items: center;
  gap: 8px;
  border: 0;
  border-radius: 12px;
  height: 42px;
  padding: 0 16px;
  color: #fff;
  font-weight: 800;
  font-size: 13px;
  letter-spacing: .04em;
  text-transform: uppercase;
  cursor: pointer;
  font-family: inherit;
}
.vp-btn:disabled { opacity: .7; cursor: default; }
.vp-btn-green { background: #12b76a; box-shadow: 0 8px 16px rgba(18, 183, 106, .28); }
.vp-btn-blue { background: #2f6fed; box-shadow: 0 8px 16px rgba(47, 111, 237, .28); }
.vp-panel {
  background: #fff;
  border-radius: 22px;
  margin-top: 16px;
  padding: 16px 16px 6px;
  box-shadow: 0 16px 40px rgba(15, 23, 42, .06);
}
.vp-filters {
  display: grid;
  grid-template-columns: 1.15fr 1.15fr 1.15fr 1fr 1fr 1.35fr;
  gap: 12px;
  margin-bottom: 8px;
}
.vp-filter {
  display: flex;
  align-items: center;
  gap: 8px;
  min-height: 58px;
  padding: 6px 10px 6px 12px;
  border: 1px solid #e6ebf2;
  border-radius: 14px;
  background: #fff;
}
.vp-filter-copy { flex: 1; min-width: 0; }
.vp-filter-label {
  display: block;
  font-size: 11px;
  color: #94a3b8;
  line-height: 1;
  margin-bottom: -2px;
}
.vp-filter-ico { flex: none; }
.ico-ok { color: #16a34a !important; }
.ico-curso { color: #7c3aed !important; }
.ico-nivel { color: #16a34a !important; }
.ico-fecha { color: #94a3b8 !important; }
.vp-filter ::v-deep .v-input { margin: 0; padding: 0; }
.vp-filter ::v-deep .v-input__control { min-height: 28px; }
.vp-filter ::v-deep .v-input__slot {
  background: transparent !important;
  box-shadow: none !important;
  padding: 0 !important;
  min-height: 28px !important;
}
.vp-filter ::v-deep .v-select__selection,
.vp-filter ::v-deep input {
  color: #0f172a;
  font-weight: 600;
  font-size: 14px;
}
.vp-filter-search ::v-deep input::placeholder { color: #94a3b8; font-weight: 500; }
.vp-th { display: inline-flex; align-items: center; gap: 6px; color: #64748b; font-weight: 700; }
.vp-money { font-weight: 700; color: #0f172a; }
.vp-fecha { display: inline-flex; align-items: center; color: #334155; }
.vp-badge {
  display: inline-flex;
  align-items: center;
  gap: 4px;
  border-radius: 999px;
  padding: 4px 10px 4px 8px;
  color: #fff;
  font-size: 12px;
  font-weight: 700;
  line-height: 1.2;
}
.vp-badge.is-aprobado { background: #16a34a; }
.vp-badge.is-rechazado { background: #ef4444; }
.vp-badge.is-en_revision { background: #f59e0b; }
.vp-badge.is-pendiente { background: #64748b; }
.vp-vigente {
  display: inline-block;
  margin-left: 6px;
  font-size: 11px;
  font-weight: 700;
  color: #1d4ed8;
}
.vp-age { display: inline-flex; align-items: center; gap: 4px; color: #64748b; }
.vp-age.is-late { color: #b91c1c; font-weight: 700; }
.vp-late {
  margin-left: 6px;
  background: #fee2e2;
  color: #b91c1c;
  border-radius: 999px;
  font-size: 11px;
  font-weight: 800;
  padding: 2px 6px;
}
.vp-eye {
  width: 34px;
  height: 34px;
  border-radius: 999px;
  border: 1px solid #e2e8f0;
  background: #fff;
  color: #64748b;
  cursor: pointer;
  display: inline-flex;
  align-items: center;
  justify-content: center;
}
.vp-eye:hover { background: #f8fafc; }
.vp-foot-count { display: inline-flex; align-items: center; color: #64748b; font-size: 13px; }
.vp-table ::v-deep .v-data-table-header { background: #f8fafc; }
.vp-table ::v-deep th {
  color: #64748b !important;
  font-size: 12.5px !important;
  border-bottom: 1px solid #eef2f7 !important;
  height: 46px !important;
}
.vp-table ::v-deep td {
  border-bottom: 1px solid #f1f5f9 !important;
  color: #334155;
  font-size: 13.5px;
  height: 54px !important;
}
.vp-table ::v-deep tbody tr:hover { background: #f8fafc !important; }
.vp-table ::v-deep .v-data-footer {
  border-top: 1px solid #eef2f7 !important;
  color: #64748b;
  flex-wrap: wrap;
}
.vp-table ::v-deep .v-data-footer__pagination {
  order: -1;
  margin-left: 4px;
  margin-right: auto;
}
.vp-table ::v-deep .v-data-footer__select { margin-left: auto; }
@media (max-width: 1100px) {
  .vp-filters { grid-template-columns: 1fr 1fr 1fr; }
}
@media (max-width: 700px) {
  .vp-filters { grid-template-columns: 1fr; }
  .vp-hero h1 { font-size: 22px; }
}
.rs-card { border-radius: 22px !important; overflow: hidden; }
.rs-head {
  display: flex;
  justify-content: space-between;
  gap: 16px;
  padding: 22px 24px 18px;
  background: linear-gradient(115deg, #0c1b40 0%, #122a5c 70%);
  color: #fff;
}
.rs-kicker { margin: 0 0 4px; font-size: 11px; font-weight: 800; letter-spacing: .08em; text-transform: uppercase; color: rgba(255,255,255,.65); }
.rs-head h2 { margin: 0; font-size: 24px; font-weight: 800; letter-spacing: -0.02em; }
.rs-head p { margin: 6px 0 0; max-width: 460px; color: rgba(255,255,255,.75); font-size: 13.5px; }
.rs-close {
  width: 36px;
  height: 36px;
  border: 0;
  border-radius: 999px;
  background: rgba(255,255,255,.12);
  color: #fff;
  cursor: pointer;
  flex: none;
}
.rs-body { padding: 20px 24px 24px; background: #f8fafc; }
.rs-rango { display: grid; grid-template-columns: 1fr 1fr auto; gap: 12px; align-items: end; }
.rs-field { display: flex; flex-direction: column; gap: 6px; }
.rs-field span { font-size: 12px; font-weight: 700; color: #64748b; }
.rs-field input {
  height: 44px;
  border: 1px solid #e6ebf2;
  border-radius: 12px;
  padding: 0 12px;
  background: #fff;
  color: #0f172a;
  font: inherit;
}
.rs-calc { height: 44px; }
.rs-result { margin-top: 18px; }
.rs-stats { display: grid; grid-template-columns: 1.4fr .8fr; gap: 12px; }
.rs-stat {
  background: #fff;
  border: 1px solid #e6ebf2;
  border-radius: 16px;
  padding: 16px 18px;
}
.rs-stat span { display: block; font-size: 12px; font-weight: 700; color: #64748b; text-transform: uppercase; letter-spacing: .04em; }
.rs-stat strong { display: block; margin-top: 6px; font-size: 28px; font-weight: 800; color: #0f172a; letter-spacing: -0.03em; }
.rs-stat small { color: #64748b; }
.rs-stat.is-money { background: #ecfdf3; border-color: #bbf7d0; }
.rs-stat.is-money strong { color: #15803d; }
.rs-stat.is-out strong { color: #b91c1c; }
.rs-result h3 { margin: 18px 0 10px; font-size: 14px; font-weight: 800; color: #0f172a; }
.rs-estados { display: flex; flex-wrap: wrap; gap: 8px; }
.rs-cursos { display: flex; flex-direction: column; gap: 8px; }
.rs-curso {
  display: flex;
  justify-content: space-between;
  align-items: center;
  gap: 12px;
  background: #fff;
  border: 1px solid #e6ebf2;
  border-radius: 14px;
  padding: 12px 14px;
}
.rs-curso strong { display: block; color: #0f172a; }
.rs-curso span { color: #64748b; font-size: 13px; }
.rs-curso-nums { text-align: right; }
.rs-curso-nums em { display: block; font-style: normal; color: #64748b; font-size: 12px; }
.rs-curso-nums b { color: #0f172a; font-size: 16px; }
.rs-empty { margin: 0; color: #64748b; }
.rs-excel { margin-top: 18px; }
@media (max-width: 700px) {
  .rs-rango, .rs-stats { grid-template-columns: 1fr; }
}
.comprobante-box {
  border: 1px solid rgba(0, 0, 0, 0.12);
  border-radius: 8px;
  overflow: auto;
  max-height: 480px;
}
.comprobante-img {
  max-width: 100%;
  display: block;
}
.comprobante-frame {
  width: 100%;
  height: 480px;
  border: 1px solid rgba(0, 0, 0, 0.12);
  border-radius: 8px;
}
</style>
